import { Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Component({
  selector: 'app-activity-cart',
  templateUrl: './activity-cart.component.html',
  styleUrls: ['./activity-cart.component.scss', './../activities-lite.component.scss']
})
export class ActivityCartComponent implements OnInit {
  @ViewChild('deleteConfirmationDialog')  deleteConfirmationDialog;
  constructor(public dialog: MatDialog) { }
  ngOnInit(): void {
  }
  getPopup() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(this.deleteConfirmationDialog, dialogConfig);
  }
  onNoClick() {
    this.dialog.closeAll();
  }
  
  
}
